import { View, Text } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { centsToDollars, parsePrice } from "helpers/price";

export function PaymentSummary({
  styles,
  paymentsInfo,
  showPaymentPlanInfo,
  paymentPlanInfo,
  paymentInfoFull,
  cardData,
  secondCardData,
  directPayNote,
}: {
  styles: any;
  paymentsInfo: any;
  showPaymentPlanInfo: boolean;
  paymentPlanInfo: any;
  paymentInfoFull: any;
  cardData: any;
  secondCardData: any;
  directPayNote?: string | null;
}) {
  return (
    <View style={styles.section} wrap>
      <Text style={styles.title}>Payment Summary</Text>
      <View style={styles.paymentItem}>
        <Text style={styles.text}>
          {paymentsInfo?.allPaidPayments?.length <= 1
            ? `Total Paid on : ${parseDate(
                paymentsInfo?.allPaidPayments[0]?.createdAt,
                false,
                true
              )}`
            : "Total Paid:"}
        </Text>
        <Text style={styles.amount}>
          {parsePrice(centsToDollars(paymentsInfo.totalPaid))}
        </Text>
      </View>
      {paymentsInfo?.allPaidPayments?.length > 1 &&
        paymentsInfo?.allPaidPayments?.map((payment: any) => (
          <View style={{ ...styles.paymentItem, ...styles.paymentSubItem }}>
            <Text style={{ ...styles.text, ...styles.textSmall }}>
              {payment.status} on:{"  "}
              {parseDate(payment?.createdAt, false, true)}
            </Text>
            <Text style={{ ...styles.amount, ...styles.textSmall }}>
              {parsePrice(centsToDollars(payment.amountInCents))}
            </Text>
          </View>
        ))}
      <View style={styles.divider} />
      {paymentsInfo?.allRefundedPayments?.length > 0 && (
        <View style={{ ...styles.paymentItem, marginTop: "5px" }}>
          <Text style={styles.text}>
            {paymentsInfo?.allRefundedPayments?.length <= 1
              ? `Total Refunded on ${parseDate(
                  paymentsInfo?.allRefundedPayments[0]?.createdAt,
                  false,
                  true
                )}`
              : "Total Refunded:"}
          </Text>
          <Text style={styles.amount}>
            {parsePrice(centsToDollars(paymentsInfo.totalRefunded))}
          </Text>
        </View>
      )}
      {paymentsInfo?.allRefundedPayments?.length > 1 &&
        paymentsInfo?.allRefundedPayments?.map((payment: any) => (
          <View
            style={{
              ...styles.paymentItem,
              ...styles.paymentSubItem,
            }}
          >
            <Text style={{ ...styles.text, ...styles.textSmall }}>
              {payment.status} on:{"  "}
              {parseDate(payment?.createdAt, false, true)}
            </Text>
            <Text style={{ ...styles.amount, ...styles.textSmall }}>
              {parsePrice(centsToDollars(payment.amountInCents))}
            </Text>
          </View>
        ))}
      {paymentsInfo?.allRefundedPayments?.length && (
        <View style={styles.divider} />
      )}
      {paymentsInfo && paymentsInfo?.sortedAllPayments?.length > 1 && (
        <View style={styles.paymentItem}>
          <Text style={styles.totalAmountTitle}>
            {paymentsInfo.isTotalAdjusted ? "Adjusted Total" : "Total"}
          </Text>
          <Text style={styles.bundlePrice}>
            {parsePrice(centsToDollars(paymentsInfo?.totalPaidAmount || 0))}
          </Text>
        </View>
      )}
      {showPaymentPlanInfo &&
        paymentPlanInfo &&
        !paymentPlanInfo?.isDownPaymentOnly && (
          <View style={styles.paymentItem}>
            <Text style={styles.totalAmountTitle}>Remaining:</Text>
            <Text style={styles.bundlePrice}>
              {parsePrice(
                centsToDollars(paymentPlanInfo?.remainingAmountInCents || 0)
              )}
            </Text>
          </View>
        )}
      {showPaymentPlanInfo &&
        paymentPlanInfo?.showInstallmentsInfo &&
        !paymentPlanInfo?.isDownPaymentOnly && (
          <View style={styles.installmentsInfoContainer}>
            <Text style={styles.installmentsInfoItem}>
              {paymentPlanInfo.remainingInstallmentsCount} payments of{" "}
              {parsePrice(
                centsToDollars(
                  paymentPlanInfo.installments?.find(
                    (installment: any) => !installment.paymentId
                  )?.amountInCents || 0
                )
              )}{" "}
              /month {"  "} Next Due: {paymentPlanInfo.nextInstallmentDate}
            </Text>
          </View>
        )}
      {directPayNote && (
        <View style={{ ...styles.paymentItem, marginTop: "10px" }}>
          <Text style={styles.text}>Note:</Text>
          <Text style={{ ...styles.text, color: "#0D0D0D" }}>
            {directPayNote}
          </Text>
        </View>
      )}
      {cardData?.data && (
        <View style={{ ...styles.paymentItem, marginTop: "10px" }}>
          <Text style={styles.text}>Method:</Text>
          <Text style={{ ...styles.text, color: "#0D0D0D" }}>
            {!showPaymentPlanInfo && paymentInfoFull?.firstPayment?.type}
            {showPaymentPlanInfo &&
              paymentPlanInfo?.lastPayment?.type} (type:{" "}
            {cardData?.data?.brand.toUpperCase() || "N/A"}) ending{" "}
            {cardData?.data?.last4 || "N/A"}
          </Text>
        </View>
      )}
      {secondCardData?.data && (
        <View style={{ ...styles.paymentItem, marginBottom: "0px" }}>
          <Text style={styles.text}>Second Method:</Text>
          <Text style={{ ...styles.text, color: "#0D0D0D" }}>
            Card (type: {secondCardData.data.brand.toUpperCase() || "N/A"})
            ending {secondCardData.data.last4 || "N/A"}
          </Text>
        </View>
      )}
    </View>
  );
}
